import { ISearchPage, IPage } from "@/types/AppTypes";
import { httpRequest } from "@/utils/HttpRequest";
import { IAboutUsDetail } from "../aboutUs/aboutUsService";
import { IIntroductionsDetail } from "../introductions/introductionsService";


//详情
export interface ICardcaseDetail {
    address?: string,  // "郑汴路与玉凤路交叉口向南500米"
    address1?: string,  // "升龙凤凰城B区6号楼14层"
    businessProfiles?: string,  // null
    cardType?: string,  // "card_type.in.repair"
    code?: string,  // null
    company?: string,  // "河南万泓投资有限公司"
    companyProfiles?: string,  // null
    createTime?: string,  // "2022-02-16 14:22:23"
    createUser?: string,  // "ebcAdmin"
    deleteFlag?: string,  // 0
    ebcBusinessDto?: IIntroductionsDetail[],  // null
    ebcCompanyDto?: IAboutUsDetail[],  // null
    email?: string,  // "qianzhibin6@126.com"
    icon?: string,  // null
    id?: string,  // "9b05a76bb3222e49dca75ae7b2560180"
    init?: string,  // null
    md5?: string,  // "ffa97fdce0b54b7ab27ec4f17a6cb50f"
    name?: string,  // "钱志斌11"
    openid?: string,  // null
    orderNum?: string,  // null
    depName?: string,  // null
    page?: string,  // null
    phone?: string,  // "18937115777"
    position?: string,  // "总经理"
    qrCode?: string,  // null
    status?: string,  // null
    tel?: string,  // "0371-86617977"
    title?: string,  // null
    typeCode?: string,  // "card_type"
    typeName?: string,  // "默认"
    updateTime?: string,  // null
    updateUser?: string,  // null
    userEntityId?: string,  // "290"
    wechat?: string,  // null
    cardcaseId?: string,  // null
}

//新增
export interface ICardcaseInsert extends ICardcaseDetail {

}

//编辑
export interface ICardcaseUpdate extends ICardcaseInsert {
    id: string,
}

//搜索条件
export interface ICardcaseSearchFields {
    "userEntityId"?: string,   // "34",
    "name"?: string,   // "test",
    "phone"?: string,   // "1234",
    "typeName"?: string,   // "名片属性默认"
}
export interface ICmSearchPageFields extends ISearchPage {
    "userEntityId"?: string,   // "34",
    "name"?: string,   // "test",
    "phone"?: string,   // "1234",
    "typeName"?: string,   // "名片属性默认"
}
export interface ICardcaseSearch
    extends ICardcaseSearchFields, ICmSearchPageFields {
}

//表单字段
export interface ICardcaseFormFields extends ICardcaseDetail {

}

export interface ICardGroupDetail {
    "id"?: string,   // ""
    "userEntityId"?: string,   // "1",
    "code"?: string,   // "1",
    "name"?: string,   // "员工姓名"
    [key: string]: any
}
class CardcaseService {
    /** 获取名片夹列表*/
    async page(searchVo: ICardcaseSearch) {
        const apiUrl = `/ebc/cardcase/search/pg?groupBy=1`;
        return await httpRequest.post<IPage<ICardcaseDetail>>(apiUrl, searchVo);
    }
    async insert(insertVo: ICardcaseInsert) {
        const apiUrl = "/ebc/card/insertCustomer";
        return await httpRequest.post<boolean>(apiUrl, insertVo);
    }
    async update(updateVo: ICardcaseUpdate) {
        const apiUrl = "/ebc/cardcase/update";
        return await httpRequest.post<boolean>(apiUrl, updateVo);
    }
    //启用禁用
    async disable(id: string) {
        const apiUrl = `/ebc/cardcase/delete/${id}`;
        return await httpRequest.get<boolean>(apiUrl);
    }

    /*分组查询 */
    async groupPage(searchVo: ICardcaseSearch) {
        const apiUrl = `/ebc/cardcaseGroup/search/pg`;
        return await httpRequest.post<IPage<ICardGroupDetail>>(apiUrl, searchVo);
    }
    /*名片夹分组新增 */
    async groupInsert(updateVo: ICardGroupDetail) {
        const apiUrl = "/ebc/cardcaseGroup/insert";
        return await httpRequest.post<boolean>(apiUrl, updateVo);
    }
    /*名片夹分组编辑 */
    async groupUpdate(updateVo: ICardGroupDetail) {
        const apiUrl = "/ebc/cardcaseGroup/update";
        return await httpRequest.post<boolean>(apiUrl, updateVo);
    }
}

export const cardcaseService = new CardcaseService();
